import LIVESTREAM_TYPE_OPTIONS from './livestreamTypeOptions'

// What each stream tier offers, as one table. Mirrors StreamTypeCapabilities on the backend —
// keep the two in step, since the backend enforces this and the UI only reflects it.
export const STREAM_FEATURES = {
  // Sponsor logos composited onto the court, plus the competition logo on the cards. The team
  // names those graphics render come with them.
  COURT_LOGOS: 'COURT_LOGOS',
  // The MediaLive channel and ads-orchestrator sidecar that can cut away from the camera.
  AD_INSERTION: 'AD_INSERTION',
  // Commentary from the venue over a microphone plugged into the camera; switches the camera's
  // audio source at stream start. Distinct from STUDIO, which mixes a remote operator in the pod.
  LOCAL_COMMENTARY: 'LOCAL_COMMENTARY',
  // Per-event sponsor MP4s played back during the broadcast.
  SPONSOR_VIDEOS: 'SPONSOR_VIDEOS',
  // Remote-commentary Studio: assigning an operator to a game.
  STUDIO: 'STUDIO',
  // The Studio operator tracking score, period and clock as the game's scoreboard source.
  MANUAL_SCOREBOARD: 'MANUAL_SCOREBOARD',
}

const FEATURES_BY_TIER = {
  // Deprecated: no new static streams, and the existing ones carry nothing.
  [LIVESTREAM_TYPE_OPTIONS.LIVESTREAM_STATIC]: [],
  [LIVESTREAM_TYPE_OPTIONS.LIVESTREAM_LITE]: [],
  [LIVESTREAM_TYPE_OPTIONS.LIVESTREAM_PLUS]: [
    STREAM_FEATURES.COURT_LOGOS,
    STREAM_FEATURES.AD_INSERTION,
  ],
  [LIVESTREAM_TYPE_OPTIONS.LIVESTREAM_PRO]: [
    STREAM_FEATURES.COURT_LOGOS,
    STREAM_FEATURES.AD_INSERTION,
    STREAM_FEATURES.SPONSOR_VIDEOS,
    STREAM_FEATURES.STUDIO,
    STREAM_FEATURES.LOCAL_COMMENTARY,
    STREAM_FEATURES.MANUAL_SCOREBOARD,
  ],
}

// Whether a tier offers a feature. An event with no tier yet offers nothing.
export const supports = (livestreamType, feature) =>
  Boolean(livestreamType) && (FEATURES_BY_TIER[livestreamType] ?? []).includes(feature)

export default { STREAM_FEATURES, supports }
